module.exports = __webpack_public_path__ + "static/media/o2o_web02.5f974b94.png";